var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-container',[_c('el-main',[_c('pig-button'),_c('global-head'),_c('div',[_vm._v("嘀嘀嘀vercel测试")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }